export default __webpack_public_path__ + "static/4-cf61ef371ca43f076879aa9d3ec6a3d4.png";